import { IWorkspace } from '../../types';

// Workspace Action Types
export enum WorkspaceActionTypes {
  // Get all workspaces actions
  GET_ALL_WORKSPACES_REQUEST = 'GET_ALL_WORKSPACES_REQUEST',
  GET_ALL_WORKSPACES_SUCCESS = 'GET_ALL_WORKSPACES_SUCCESS',
  GET_ALL_WORKSPACES_FAILURE = 'GET_ALL_WORKSPACES_FAILURE',

  // Get admin workspaces actions
  GET_ADMIN_WORKSPACES_REQUEST = 'GET_ADMIN_WORKSPACES_REQUEST',
  GET_ADMIN_WORKSPACES_SUCCESS = 'GET_ADMIN_WORKSPACES_SUCCESS',
  GET_ADMIN_WORKSPACES_FAILURE = 'GET_ADMIN_WORKSPACES_FAILURE',

  // Get workspace by ID actions
  GET_WORKSPACE_BY_ID_REQUEST = 'GET_WORKSPACE_BY_ID_REQUEST',
  GET_WORKSPACE_BY_ID_SUCCESS = 'GET_WORKSPACE_BY_ID_SUCCESS',
  GET_WORKSPACE_BY_ID_FAILURE = 'GET_WORKSPACE_BY_ID_FAILURE',

  // Create workspace actions
  CREATE_WORKSPACE_REQUEST = 'CREATE_WORKSPACE_REQUEST',
  CREATE_WORKSPACE_SUCCESS = 'CREATE_WORKSPACE_SUCCESS',
  CREATE_WORKSPACE_FAILURE = 'CREATE_WORKSPACE_FAILURE',

  // Update workspace actions
  UPDATE_WORKSPACE_REQUEST = 'UPDATE_WORKSPACE_REQUEST',
  UPDATE_WORKSPACE_SUCCESS = 'UPDATE_WORKSPACE_SUCCESS',
  UPDATE_WORKSPACE_FAILURE = 'UPDATE_WORKSPACE_FAILURE',

  // Delete workspace actions
  DELETE_WORKSPACE_REQUEST = 'DELETE_WORKSPACE_REQUEST',
  DELETE_WORKSPACE_SUCCESS = 'DELETE_WORKSPACE_SUCCESS',
  DELETE_WORKSPACE_FAILURE = 'DELETE_WORKSPACE_FAILURE',

  // Switch workspace actions
  SWITCH_WORKSPACE_REQUEST = 'SWITCH_WORKSPACE_REQUEST',
  SWITCH_WORKSPACE_SUCCESS = 'SWITCH_WORKSPACE_SUCCESS',
  SWITCH_WORKSPACE_FAILURE = 'SWITCH_WORKSPACE_FAILURE',

  // Remove user actions
  REMOVE_USER_FROM_WORKSPACE_REQUEST = 'REMOVE_USER_FROM_WORKSPACE_REQUEST',
  REMOVE_USER_FROM_WORKSPACE_SUCCESS = 'REMOVE_USER_FROM_WORKSPACE_SUCCESS',
  REMOVE_USER_FROM_WORKSPACE_FAILURE = 'REMOVE_USER_FROM_WORKSPACE_FAILURE',

  // Update workspace settings actions
  UPDATE_WORKSPACE_SETTINGS_REQUEST = 'UPDATE_WORKSPACE_SETTINGS_REQUEST',
  UPDATE_WORKSPACE_SETTINGS_SUCCESS = 'UPDATE_WORKSPACE_SETTINGS_SUCCESS',
  UPDATE_WORKSPACE_SETTINGS_FAILURE = 'UPDATE_WORKSPACE_SETTINGS_FAILURE',

  // Get archived workspaces actions
  GET_ARCHIVED_WORKSPACES_REQUEST = 'GET_ARCHIVED_WORKSPACES_REQUEST',
  GET_ARCHIVED_WORKSPACES_SUCCESS = 'GET_ARCHIVED_WORKSPACES_SUCCESS',
  GET_ARCHIVED_WORKSPACES_FAILURE = 'GET_ARCHIVED_WORKSPACES_FAILURE',

  // Archive workspace actions
  ARCHIVE_WORKSPACE_REQUEST = 'ARCHIVE_WORKSPACE_REQUEST',
  ARCHIVE_WORKSPACE_SUCCESS = 'ARCHIVE_WORKSPACE_SUCCESS',
  ARCHIVE_WORKSPACE_FAILURE = 'ARCHIVE_WORKSPACE_FAILURE',

  // Clear workspace actions
  CLEAR_WORKSPACE_STATE = 'CLEAR_WORKSPACE_STATE',
  CLEAR_WORKSPACE_DATA = 'CLEAR_WORKSPACE_DATA',
}

// Workspace Action Interfaces
export interface GetAllWorkspacesRequestAction {
  type: WorkspaceActionTypes.GET_ALL_WORKSPACES_REQUEST;
}

export interface GetAllWorkspacesSuccessAction {
  type: WorkspaceActionTypes.GET_ALL_WORKSPACES_SUCCESS;
  payload: IWorkspace[];
}

export interface GetAllWorkspacesFailureAction {
  type: WorkspaceActionTypes.GET_ALL_WORKSPACES_FAILURE;
  payload: string;
}

export interface GetAdminWorkspacesRequestAction {
  type: WorkspaceActionTypes.GET_ADMIN_WORKSPACES_REQUEST;
  payload?: { isAdmin?: boolean };
}

export interface GetAdminWorkspacesSuccessAction {
  type: WorkspaceActionTypes.GET_ADMIN_WORKSPACES_SUCCESS;
  payload: IWorkspace[];
}

export interface GetAdminWorkspacesFailureAction {
  type: WorkspaceActionTypes.GET_ADMIN_WORKSPACES_FAILURE;
  payload: string;
}

export interface GetWorkspaceByIdRequestAction {
  type: WorkspaceActionTypes.GET_WORKSPACE_BY_ID_REQUEST;
  payload: string;
}

export interface GetWorkspaceByIdSuccessAction {
  type: WorkspaceActionTypes.GET_WORKSPACE_BY_ID_SUCCESS;
  payload: IWorkspace;
}

export interface GetWorkspaceByIdFailureAction {
  type: WorkspaceActionTypes.GET_WORKSPACE_BY_ID_FAILURE;
  payload: string;
}

export interface CreateWorkspaceRequestAction {
  type: WorkspaceActionTypes.CREATE_WORKSPACE_REQUEST;
  payload: { name: string };
}

export interface CreateWorkspaceSuccessAction {
  type: WorkspaceActionTypes.CREATE_WORKSPACE_SUCCESS;
  payload: IWorkspace;
}

export interface CreateWorkspaceFailureAction {
  type: WorkspaceActionTypes.CREATE_WORKSPACE_FAILURE;
  payload: string;
}

export interface UpdateWorkspaceRequestAction {
  type: WorkspaceActionTypes.UPDATE_WORKSPACE_REQUEST;
  payload: { name: string };
}

export interface UpdateWorkspaceSuccessAction {
  type: WorkspaceActionTypes.UPDATE_WORKSPACE_SUCCESS;
  payload: IWorkspace;
}

export interface UpdateWorkspaceFailureAction {
  type: WorkspaceActionTypes.UPDATE_WORKSPACE_FAILURE;
  payload: string;
}

export interface DeleteWorkspaceRequestAction {
  type: WorkspaceActionTypes.DELETE_WORKSPACE_REQUEST;
  payload: string;
}

export interface DeleteWorkspaceSuccessAction {
  type: WorkspaceActionTypes.DELETE_WORKSPACE_SUCCESS;
  payload: string;
}

export interface DeleteWorkspaceFailureAction {
  type: WorkspaceActionTypes.DELETE_WORKSPACE_FAILURE;
  payload: string;
}

export interface SwitchWorkspaceRequestAction {
  type: WorkspaceActionTypes.SWITCH_WORKSPACE_REQUEST;
  payload: string;
}

export interface SwitchWorkspaceSuccessAction {
  type: WorkspaceActionTypes.SWITCH_WORKSPACE_SUCCESS;
  payload: string; // workspaceId
}

export interface SwitchWorkspaceFailureAction {
  type: WorkspaceActionTypes.SWITCH_WORKSPACE_FAILURE;
  payload: string;
}

export interface ClearWorkspaceStateAction {
  type: WorkspaceActionTypes.CLEAR_WORKSPACE_STATE;
}

export interface RemoveUserFromWorkspaceRequestAction {
  type: WorkspaceActionTypes.REMOVE_USER_FROM_WORKSPACE_REQUEST;
  payload: { userId: string };
}

export interface RemoveUserFromWorkspaceSuccessAction {
  type: WorkspaceActionTypes.REMOVE_USER_FROM_WORKSPACE_SUCCESS;
  payload: string; // success message
}

export interface RemoveUserFromWorkspaceFailureAction {
  type: WorkspaceActionTypes.REMOVE_USER_FROM_WORKSPACE_FAILURE;
  payload: string;
}

export interface ClearWorkspaceDataAction {
  type: WorkspaceActionTypes.CLEAR_WORKSPACE_DATA;
}

export interface UpdateWorkspaceSettingsRequestAction {
  type: WorkspaceActionTypes.UPDATE_WORKSPACE_SETTINGS_REQUEST;
  payload: {
    duplicateEmailEnabled: boolean;
  };
}

export interface UpdateWorkspaceSettingsSuccessAction {
  type: WorkspaceActionTypes.UPDATE_WORKSPACE_SETTINGS_SUCCESS;
  payload: {
    message: string;
    duplicateEmailEnabled: boolean;
  };
}

export interface UpdateWorkspaceSettingsFailureAction {
  type: WorkspaceActionTypes.UPDATE_WORKSPACE_SETTINGS_FAILURE;
  payload: string;
}

export interface GetArchivedWorkspacesRequestAction {
  type: WorkspaceActionTypes.GET_ARCHIVED_WORKSPACES_REQUEST;
}

export interface GetArchivedWorkspacesSuccessAction {
  type: WorkspaceActionTypes.GET_ARCHIVED_WORKSPACES_SUCCESS;
  payload: IWorkspace[];
}

export interface GetArchivedWorkspacesFailureAction {
  type: WorkspaceActionTypes.GET_ARCHIVED_WORKSPACES_FAILURE;
  payload: string;
}

export interface ArchiveWorkspaceRequestAction {
  type: WorkspaceActionTypes.ARCHIVE_WORKSPACE_REQUEST;
  payload: string; // workspaceId
}

export interface ArchiveWorkspaceSuccessAction {
  type: WorkspaceActionTypes.ARCHIVE_WORKSPACE_SUCCESS;
  payload: string; // workspaceId
}

export interface ArchiveWorkspaceFailureAction {
  type: WorkspaceActionTypes.ARCHIVE_WORKSPACE_FAILURE;
  payload: string;
}

// Union type for all workspace actions
export type WorkspaceAction =
  | GetAllWorkspacesRequestAction
  | GetAllWorkspacesSuccessAction
  | GetAllWorkspacesFailureAction
  | GetAdminWorkspacesRequestAction
  | GetAdminWorkspacesSuccessAction
  | GetAdminWorkspacesFailureAction
  | GetWorkspaceByIdRequestAction
  | GetWorkspaceByIdSuccessAction
  | GetWorkspaceByIdFailureAction
  | CreateWorkspaceRequestAction
  | CreateWorkspaceSuccessAction
  | CreateWorkspaceFailureAction
  | UpdateWorkspaceRequestAction
  | UpdateWorkspaceSuccessAction
  | UpdateWorkspaceFailureAction
  | DeleteWorkspaceRequestAction
  | DeleteWorkspaceSuccessAction
  | DeleteWorkspaceFailureAction
  | SwitchWorkspaceRequestAction
  | SwitchWorkspaceSuccessAction
  | SwitchWorkspaceFailureAction
  | RemoveUserFromWorkspaceRequestAction
  | RemoveUserFromWorkspaceSuccessAction
  | RemoveUserFromWorkspaceFailureAction
  | UpdateWorkspaceSettingsRequestAction
  | UpdateWorkspaceSettingsSuccessAction
  | UpdateWorkspaceSettingsFailureAction
  | GetArchivedWorkspacesRequestAction
  | GetArchivedWorkspacesSuccessAction
  | GetArchivedWorkspacesFailureAction
  | ArchiveWorkspaceRequestAction
  | ArchiveWorkspaceSuccessAction
  | ArchiveWorkspaceFailureAction
  | ClearWorkspaceStateAction
  | ClearWorkspaceDataAction;

// Workspace State interface
export interface WorkspaceState {
  // Workspace data
  workspaces: IWorkspace[];
  adminWorkspaces: IWorkspace[];
  archivedWorkspaces: IWorkspace[];
  workspace: IWorkspace | null;
  // Loading states
  loading: boolean;
  getAllWorkspacesLoading: boolean;
  getAdminWorkspacesLoading: boolean;
  getArchivedWorkspacesLoading: boolean;
  archiveWorkspaceLoading: boolean;
  getWorkspaceByIdLoading: boolean;
  createWorkspaceLoading: boolean;
  updateWorkspaceLoading: boolean;
  deleteWorkspaceLoading: boolean;
  switchWorkspaceLoading: boolean;
  removeUserLoading: boolean;
  updateWorkspaceSettingsLoading: boolean;

  // Error states
  error: string | null;
  getAllWorkspacesError: string | null;
  getAdminWorkspacesError: string | null;
  getWorkspaceByIdError: string | null;
  createWorkspaceError: string | null;
  updateWorkspaceError: string | null;
  deleteWorkspaceError: string | null;
  switchWorkspaceError: string | null;
  removeUserError: string | null;
  updateWorkspaceSettingsError: string | null;
  getArchivedWorkspacesError: string | null;
  archiveWorkspaceError: string | null;

  // Success states
  success: string | null;
  getAllWorkspacesSuccess: boolean;
  getAdminWorkspacesSuccess: boolean;
  getWorkspaceByIdSuccess: boolean;
  createWorkspaceSuccess: boolean;
  updateWorkspaceSuccess: boolean;
  deleteWorkspaceSuccess: boolean;
  switchWorkspaceSuccess: boolean;
  removeUserSuccess: boolean;
  updateWorkspaceSettingsSuccess: string | null;
  getArchivedWorkspacesSuccess: boolean;
  archiveWorkspaceSuccess: boolean;
}
